import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Fifteenththeme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Electric Violet */
            --primary: #8b5cf6;       /* Violet 500 */
            --primary-dark: #6d28d9;  /* Violet 700 */
            --primary-light: #a78bfa; /* Violet 400 */
            --accent: #f472b6;        /* Pink 400 */
            --bg-body: #0f172a;       /* Slate 900 (Dark) */
            --bg-card: #1e293b;       /* Slate 800 */
            --text-main: #f8fafc;     /* Slate 50 */
            --text-muted: #94a3b8;    /* Slate 400 */

            --font-head: 'Outfit', sans-serif;
            --font-body: 'Outfit', sans-serif;

            --radius-xl: 24px;
            --shadow-glow: 0 0 20px rgba(139, 92, 246, 0.3);
            --gradient-main: linear-gradient(135deg, #8b5cf6 0%, #d946ef 100%);
        }

        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
        }

        body {
            font-family: var(--font-body);
            color: var(--text-main);
            background-color: var(--bg-body);
            line-height: 1.6;
        }

        h1, h2, h3, h4, h5 {
            font-family: var(--font-head);
            font-weight: 700;
            line-height: 1.2;
        }
        
        h1 {
            background: var(--gradient-main);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        a {
            text-decoration: none;
            color: inherit;
            transition: 0.3s;
        }

        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 24px;
        }

        .section {
            padding: 100px 0;
        }
        
        /* Buttons */
        .btn {
            display: inline-block;
            padding: 12px 30px;
            background: var(--gradient-main);
            color: white;
            border-radius: var(--radius-xl);
            font-weight: 600;
            border: none;
            box-shadow: var(--shadow-glow);
            cursor: pointer;
            transition: transform 0.2s;
        }

        .btn:hover {
            transform: scale(1.05);
        }

        .btn-outline {
            display: inline-block;
            padding: 12px 30px;
            background: transparent;
            color: var(--primary-light);
            border: 2px solid var(--primary);
            border-radius: var(--radius-xl);
            font-weight: 600;
            cursor: pointer;
        }
        
        .btn-outline:hover {
            background: rgba(139, 92, 246, 0.1);
            color: white;
        }

        /* Nav */
        .navbar {
            padding: 20px 0;
            background: rgba(15, 23, 42, 0.8);
            backdrop-filter: blur(12px);
            position: sticky;
            top: 0;
            z-index: 1000;
            border-bottom: 1px solid rgba(255,255,255,0.05);
        }

        .navbar .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        .brand {
            font-size: 1.8rem;
            font-weight: 800;
            letter-spacing: -1px;
            background: var(--gradient-main);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        .nav-links {
            display: flex;
            gap: 30px;
            background: var(--bg-card);
            padding: 10px 30px;
            border-radius: 50px;
            border: 1px solid rgba(255,255,255,0.05);
        }

        .nav-links a {
            font-weight: 500;
            color: var(--text-muted);
            font-size: 0.95rem;
        }

        .nav-links a:hover {
            color: white;
        }

        /* Hero */
        .hero {
            height: 85vh;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
            position: relative;
            overflow: hidden;
        }
        
        .hero-bg-glow {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 600px;
            height: 600px;
            background: radial-gradient(circle, rgba(139, 92, 246, 0.15) 0%, rgba(15, 23, 42, 0) 70%);
            z-index: -1;
        }

        .hero h1 {
            font-size: 5rem;
            margin-bottom: 20px;
            letter-spacing: -1px;
        }

        .hero p {
            font-size: 1.25rem;
            color: var(--text-muted);
            margin-bottom: 40px;
            max-width: 600px;
            margin-left: auto;
            margin-right: auto;
        }

        /* Section Header */
        .section-header {
            margin-bottom: 60px;
            display: flex;
            align-items: center;
            gap: 20px;
        }
        
        .section-header h2 {
            font-size: 2.5rem;
            color: white;
        }
        
        .line {
            height: 1px;
            background: var(--gradient-main);
            flex-grow: 1;
            opacity: 0.5;
        }

        /* Cards */
        .glass-card {
            background: rgba(30, 41, 59, 0.5);
            border: 1px solid rgba(255, 255, 255, 0.05);
            backdrop-filter: blur(10px);
            border-radius: var(--radius-xl);
            padding: 30px;
            transition: 0.3s;
        }

        .glass-card:hover {
            background: rgba(30, 41, 59, 0.8);
            border-color: var(--primary);
            box-shadow: var(--shadow-glow);
            transform: translateY(-5px);
        }

        /* Services */
        .services-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 30px;
        }

        .service-icon {
            width: 60px;
            height: 60px;
            background: var(--gradient-main);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            font-size: 1.5rem;
            color: white;
        }
        
        .service-icon img {
            width: 100%;
            height: 100%;
            border-radius: 12px;
            object-fit: cover;
        }
        
        .glass-card h3 {
            font-size: 1.4rem;
            margin-bottom: 10px;
            color: white;
        }
        
        .glass-card p {
            color: var(--text-muted);
            margin-bottom: 25px;
            font-size: 0.95rem;
        }
        
        /* Products */
        .products-grid {
             display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 30px;
        }
        
        .product-card {
            background: var(--bg-card);
            border-radius: var(--radius-xl);
            overflow: hidden;
            transition: 0.3s;
        }
        
        .product-card:hover {
            transform: scale(1.03);
            box-shadow: var(--shadow-glow);
        }
        
        .product-img {
            height: 200px;
            background: #000;
        }
        
        .product-img img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            opacity: 0.8;
            transition: 0.3s;
        }
        
        .product-card:hover .product-img img {
            opacity: 1;
        }
        
        .product-body {
            padding: 20px;
        }
        
        .product-body h3 {
            font-size: 1.1rem;
            margin-bottom: 5px;
            color: white;
        }
        
        .price {
            color: var(--accent);
            font-weight: 700;
            margin-bottom: 15px;
            display: block;
        }
        
        /* Reviews */
        .review-carousel {
            display: flex; 
            gap: 30px;
            overflow-x: auto;
            padding-bottom: 20px;
        }
        
        .review-card {
            min-width: 350px;
            background: var(--bg-card);
            padding: 30px;
            border-radius: 20px;
            border: 1px solid rgba(255,255,255,0.05);
        }
        
        /* Footer */
        footer {
            background: #020617;
            padding: 80px 0 30px;
            border-top: 1px solid rgba(255,255,255,0.05);
        }
        
        .footer-grid {
            display: grid;
            grid-template-columns: 2fr 1fr 1fr 1fr;
            gap: 40px;
        }
        
        .footer-brand {
            font-size: 2rem;
            font-weight: 800;
            margin-bottom: 20px; 
            color: white;
            display: block;
        }
        
        .footer h4 { color: white; margin-bottom: 20px; }
        .footer p { color: var(--text-muted); font-size: 0.9rem; margin-bottom: 10px; }
        .footer a:hover { color: var(--primary-light); }
        
        @media (max-width: 900px) {
            .services-grid, .products-grid, .footer-grid { grid-template-columns: 1fr; }
            .hero h1 { font-size: 3rem; }
            .nav-links { display: none; }
        }
            `}</style>
            
            <link rel="preconnect" href="https://fonts.googleapis.com"/>
            <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true"/>
            <link href="https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;600;800&display=swap" rel="stylesheet"/>

            <nav className="navbar">
                <div className="container">
                    <a href="#" className="brand">{get_data.service_name}</a>
                    <div className="nav-links">
                        <a href="#">Home</a>
                        <a href="#about">About</a>
                        <a href="#services">Services</a>
                        <a href="#products">Store</a>
                        <a href="#contact">Contact</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                    </div>
                </div>
            </nav>

            <header className="hero">
                <div className="hero-bg-glow"></div>
                <div className="container">
                    <h1>Future Ready.<br/>Design Driven.</h1>
                    <p>Welcome to {get_data.service_name}. We push boundaries to deliver experiences that are ahead of their time. Innovation is our language.</p>
                    <div style={{display: 'flex', gap: '20px', justifyContent: 'center'}}>
                        <a href="#services" className="btn">Explore Now</a>
                        <a href="#contact" className="btn-outline">Contact Us</a>
                    </div>
                </div>
            </header>

            <section className="section" id="about">
                <div className="container">
                    <div className="section-header">
                        <h2>About Us</h2>
                        <div className="line"></div>
                    </div>
                    <div style={{display: 'flex', gap: '50px', alignItems: 'center', flexWrap: 'wrap'}}>
                        <div style={{flex: 1}}>
                            <h3 style={{fontSize: '2rem', marginBottom: '20px', color: 'white'}}>We Don't Follow Trends.<br/>We Set Them.</h3>
                            <p style={{color: 'var(--text-muted)', marginBottom: '30px'}}>
                                Founded on the belief that good design solves problems, {get_data.service_name} is a collective of thinkers and doers. We approach every project with a fresh perspective, ensuring unique outcomes.
                            </p>
                            <a href="#contact" className="btn-outline">Our Story</a>
                        </div>
                        <div style={{flex: 1}}>
                             <img src="https://images.unsplash.com/photo-1550745165-9bc0b252726f?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80" alt="Future" style={{width: '100%', borderRadius: '24px', opacity: 0.8}} />
                        </div>
                    </div>
                </div>
            </section>

            <section className="section" id="services">
                <div className="container">
                    <div className="section-header">
                        <h2>Services</h2>
                        <div className="line"></div>
                    </div>
                    <div className="services-grid">
                        {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                            <div className="glass-card" key={index}>
                                <div className="service-icon">
                                     {item.icon ? (
                                        <img 
                                            src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`}
                                            alt={item.name}
                                        />
                                    ) : (
                                        <span>⚡</span>
                                    )}
                                </div>
                                <h3>{item.name}</h3>
                                <p>{item.description || 'Loading service details...'}</p>
                                <div style={{display: 'flex', gap: '10px'}}>
                                    <a href={`tel:${get_data.mobile}`} style={{color: 'var(--primary-light)', fontWeight: 600, fontSize: '0.9rem'}}>Call Now</a>
                                    <span style={{color: 'rgba(255,255,255,0.2)'}}>|</span>
                                    <a href="#contact" style={{color: 'var(--primary-light)', fontWeight: 600, fontSize: '0.9rem'}}>Enquire</a>
                                </div>
                            </div>
                        )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                    </div>
                </div>
            </section>

            <section className="section" id="products">
                <div className="container">
                    <div className="section-header">
                        <h2>Store</h2>
                        <div className="line"></div>
                    </div>
                    <div className="products-grid">
                        {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="product-card" key={index}>
                                <div className="product-img">
                                     {item.featured_image ? (<img 
                                        src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} 
                                        alt={item.service_name}
                                    />) : (<div className="" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555',  }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                                </div>
                                <div className="product-body">
                                    <h3>{item.service_name}</h3>
                                    {item.price && <span className="price">₹{item.price}</span>}
                                    <p style={{fontSize: '0.85rem', color: 'var(--text-muted)', marginBottom: '20px'}}>{item.description || 'Premium item.'}</p>
                                    <div style={{display: 'flex', gap: '10px', flexDirection: 'column'}}>
                                        <button onClick={() => addToCart(item)} className="btn" style={{width: '100%', fontSize: '0.9rem', padding: '10px'}}>Add to Cart</button>
                                         <div style={{display: 'flex', gap: '10px'}}>
                                            <a href={`tel:${get_data.mobile}`} className="btn-outline" style={{flex: 1, padding: '8px', fontSize: '0.8rem', textAlign: 'center'}}>Call</a>
                                            <a href="#contact" className="btn-outline" style={{flex: 1, padding: '8px', fontSize: '0.8rem', textAlign: 'center'}}>Enquiry</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            
            {/* Browse Categories Section */}
            <section className="section" id="categories">
                <div className="container">
                    <div className="section-header">
                        <h2>Categories</h2>
                        <div className="line"></div>
                    </div>
                    <div className="services-grid" style={{gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))'}}>
                        {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((cat, index) => (
                            <div key={index} className="glass-card" style={{textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                {cat.icon ? (
                                    <img src={cat.icon.startsWith('http') ? cat.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${cat.icon}`} 
                                         style={{width: '70px', height: '70px', objectFit: 'contain', marginBottom: '20px', background: 'rgba(255,255,255,0.1)', borderRadius: '12px', padding: '10px'}} alt={cat.name} />
                                ) : (
                                    <div style={{width: '70px', height: '70px', background: 'var(--gradient-main)', borderRadius: '12px', margin: '0 0 20px 0', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', color: 'white'}}>
                                        {(cat.name || 'C').charAt(0)}
                                    </div>
                                )}
                                <h3 style={{fontSize: '1.3rem', marginBottom: '15px'}}>{cat.name}</h3>
                                <div style={{display: 'flex', gap: '15px', marginTop: 'auto'}}>
                                    <a href={`tel:${get_data.mobile}`} style={{color: 'var(--primary-light)', fontWeight: 600, fontSize: '0.9rem', border: '1px solid var(--primary)', padding: '8px 15px', borderRadius: '20px'}}>Call</a>
                                    <a href="#contact" style={{background: 'var(--gradient-main)', color: 'white', fontWeight: 600, fontSize: '0.9rem', padding: '8px 15px', borderRadius: '20px'}}>Enquire</a>
                                </div>
                            </div>
                        )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                    </div>
                </div>
            </section>

            <section className="section" id="reviews">
                <div className="container">
                     <div className="section-header">
                        <h2>Testimonials</h2>
                        <div className="line"></div>
                    </div>
                    {get_data.review_ratings && get_data.review_ratings.length > 0 ? (
                        <div className="review-carousel">
                            {get_data.review_ratings.map((review, index) => (
                                <div className="review-card" key={index}>
                                     <div style={{marginBottom: '10px', color: 'var(--accent)'}}>
                                        {review.rating && <span>{'★'.repeat(Math.round(review.rating)) + '☆'.repeat(5 - Math.round(review.rating))}</span>}
                                    </div>
                                    <p style={{fontStyle: 'italic', marginBottom: '20px', color: 'var(--text-main)'}}>"{review.review || 'Excellent.'}"</p>
                                    <div style={{color: 'var(--primary-light)', fontWeight: 600}}>{review.user_name || 'Customer'}</div>
                                </div>
                            ))}
                        </div>
                    ) : (
                         <div style={{color: 'var(--text-muted)'}}>No reviews yet.</div>
                    )}
                </div>
            </section>

             <footer id="contact">
                <div className="container">
                    <div className="footer-grid">
                        <div>
                             <span className="footer-brand">{get_data.service_name}</span>
                             <p>{get_data.business_location_name}</p>
                             <div style={{marginTop: '20px', display: 'flex', gap: '15px'}}>
                                 {get_data.facebook && <a href={get_data.facebook} style={{color: 'white'}}>FB</a>}
                                 {get_data.twitter && <a href={get_data.twitter} style={{color: 'white'}}>TW</a>}
                                 {get_data.instagram && <a href={get_data.instagram} style={{color: 'white'}}>IG</a>}
                             </div>
                        </div>
                        <div className="footer">
                             <h4>Links</h4>
                             <ul>
                                <li><a href="#">Home</a></li>
                                <li><a href="#about">About</a></li>
                                <li><a href="#services">Services</a></li>
                            </ul>
                        </div>
                        <div className="footer">
                             <h4>Contact</h4>
                             <p>{get_data.email}</p>
                             <p>{get_data.mobile}</p>
                        </div>
                    </div>
                     <div style={{marginTop: '60px', textAlign: 'center', color: '#334155', fontSize: '0.9rem'}}>
                         &copy; {new Date().getFullYear()} {get_data.service_name}. All Rights Reserved.
                     </div>
                </div>
            </footer>
        </>
    );
};

export default Fifteenththeme;
